import React from "react";
import BookReview from "../../../../src/components/book-review.js";
export default {
  React,
  BookReview
};